import React, { Component } from 'react';
import JOI from 'joi-browser';
import { HTTPService } from "./../services/httpService";
import "../assets/css/SearchResult.css";
import Autocomplete from "react-google-autocomplete";
import { isMobileLocation, getBaseCoords } from "../util/locationUtils";
import { calculateDistance, forwardGeocode } from "../util/geoUtils";

const METERS_PER_MILE = 1609.344;

const API = new HTTPService()

require('dotenv').config();

export default class CustomerForm extends Component {
    state = { 
        data : {phone : "", email: ""},
        errors : {},
        name : '',
        email : "",
        phone : "",
        found : " ",
        customerId: "",
        selectedDealer:"Dealerships",
        customer : {},
        customerList: [],
        dealerList: [],
        // New dealer/customer toggle
        isDealer: false, // Default to Customer
        // Custom dropdown state
        searchTerm: "",
        filteredResults: [],
        showDropdown: false,
        selectedIndex: -1, // For keyboard navigation
        // Dealer-specific fields
        dealerData: {
            name: "",
            email: "",
            phone: "",
            address: "",
            city: "",
            state: "",
            zip: ""
        },
        dealerErrors: {},
        // Loading state for dealer creation
        creatingDealer: false,
        // Dealer group state
        dealerGroups: [],           // List of all dealer groups
        selectedDealerGroupId: '',  // Selected group ID
        newDealerGroupName: '',     // For creating new group
        isCreatingNewGroup: false,  // Toggle for "add new" mode
        newDealerAssetType: 'auto',
        // Customer edit mode
        isEditingCustomer: false    // Read-only by default when customer selected
};

     schema = {
        phone: JOI.string().length(10).required().label('phone'),
        email: JOI.string().email().required().label('email')
    }; 

    dealerSchema = {
        name: JOI.string().min(2).required().label('dealer name'),
        email: JOI.string().email().required().label('email'),
        phone: JOI.string().length(10).required().label('phone'),
        address: JOI.string().min(5).required().label('address'),
        city: JOI.string().min(2).required().label('city'),
        state: JOI.string().length(2).required().label('state'),
        zip: JOI.string().min(5).max(10).required().label('zip code')
    };

async componentDidMount() {
    // Load customers scoped to this installer. The unscoped /customers/
    // endpoint returns the global customer table — never hit it from here.
    const installerId = this.resolveInstallerId();
    if (!installerId) {
        console.error(
            '[CustomerForm] Missing installer id (props.typeId / installer.installer_id / installer.Installer_id all undefined); cannot load customer or dealer lists.',
            { hasTypeId: !!this.props.typeId, installerKeys: this.props.installer ? Object.keys(this.props.installer) : null }
        );
        this.setState({ customerList: [], dealerList: [] });
        return;
    }
    const customerRequest = `/customerInstall/${installerId}`;
    const { data: customers } = await API.get(customerRequest);
    customers.forEach(function (element) {
        element.listValue = element.customer_name + " " + element.customer_phone_number;
    });
    this.setState({ customerList: customers });

    // Load dealerships scoped to this installer + location + radius. Server
    // falls back to legacy installer-only behaviour if locationId is omitted
    // (e.g., multi-location installer with "all" selected).
    const dealerParams = new URLSearchParams();
    const dealerLocId = this.props.locationId;
    if (dealerLocId && dealerLocId !== 'all') {
        dealerParams.set('locationId', dealerLocId);
        dealerParams.set('radius_miles', '50');
    }
    const dealerQs = dealerParams.toString() ? `?${dealerParams.toString()}` : '';
    const dealerRequest = `/dealerInstall/${installerId}${dealerQs}`;
    const { data: dealers } = await API.get(dealerRequest);
    // Only active dealerships are billable — never surface inactive ones in the
    // picker, to avoid creating invoices against a closed/incorrect dealership.
    const activeDealers = (dealers || []).filter(
        d => d.is_active !== false && d.is_active !== 0 && d.is_active !== '0'
    );
    activeDealers.forEach(function (element) {
        element.listValue = element.dealer_name + " " + element.dealer_phone_number;
    });
    this.setState({ dealerList: activeDealers });

    // Load dealer groups for the dropdown
    try {
        const { data: dealerGroups } = await API.get("/dealer-groups");
        this.setState({ dealerGroups: dealerGroups || [] });
    } catch (error) {
        console.error("Error loading dealer groups:", error);
        this.setState({ dealerGroups: [] });
    }

    // NEW: Auto-search and select customer from referral data
    if (this.props.customer && this.props.customerName) {
        console.log("Auto-selecting customer from referral:", this.props.customerName);
        
        // Find the customer in the loaded list
        const matchingCustomer = customers.find(customer => 
            customer.customer_id === this.props.customer
        );
        
        if (matchingCustomer) {
            // Use existing selection logic
            this.setState({
                searchTerm: matchingCustomer.listValue,
                showDropdown: false
            });
                console.log("Calling doSubmit with customer ID:", matchingCustomer.customer_id);
                await this.doSubmit(matchingCustomer.customer_id);
                console.log("After doSubmit - state.found:", this.state.found, "state.name:", this.state.name);
        } else {
            console.log("Customer not found in list, will need to add new");
        }
    }

    if (this.props.mode === "add") {
        this.setState({ found: "N" });
    }
}

async componentDidUpdate(prevProps) {
    console.log("componentDidUpdate triggered", { 
        prevCustomer: prevProps.customer, 
        currentCustomer: this.props.customer,
        customerName: this.props.customerName,
        customerType: this.props.customerType,
        willTriggerSubmit: !prevProps.customer && this.props.customer && this.props.customerName && this.props.customerType === "retail"
    });

    // Only trigger for explicit retail customers (referrals)
    if (!prevProps.customer && this.props.customer && this.props.customerName && 
        this.props.customerType === "retail") {  // CHANGE TO EXPLICIT CHECK
        console.log("Detected new customer data from referral");
        
        const matchingCustomer = this.state.customerList.find(customer => 
            customer.customer_id === this.props.customer
        );
        
        if (matchingCustomer) {
            console.log("Calling doSubmit for customer:", matchingCustomer.customer_id);
            await this.doSubmit(matchingCustomer.customer_id);
        }
    } else {
        console.log("componentDidUpdate - conditions not met, skipping doSubmit");
    }
}

        handleToggleChange = () => {
            this.setState(prevState => ({
                isDealer: !prevState.isDealer,
                // Clear search and form data when switching
                searchTerm: "",
                filteredResults: [],
                showDropdown: false,
                found: " ",
                selectedDealer: "Dealerships",
                errors: {},
                dealerErrors: {},
                name: "",
                email: "",
                phone: "",
                address: "",
                dealerData: {
                    name: "",
                    email: "",
                    phone: "",
                    address: "",
                    city: "",
                    state: "",
                    zip: ""
                },
                // Reset dealer group state
                selectedDealerGroupId: '',
                newDealerGroupName: '',
                isCreatingNewGroup: false
            }), () => {
                // Focus the search input after state update completes
                const searchInput = document.querySelector('input[type="text"][placeholder*="search"]');
                if (searchInput) {
                    searchInput.focus();
                }
            });
        };

        async getCustomer(custId) {
            const customerRequest =  "/customers/"+custId;
            const { data : customer } = await API.get(customerRequest);
            let cust = customer[0];
            if (customer.length > 0) {
                this.setState({
                    found: "Y",
                    name: cust.customer_name,
                    email: cust.customer_Email_Address || '',
                    customerId: cust.customer_id,
                    phone: cust.customer_phone_number || '',
                    address: cust.customer_address || '',
                    customer: cust,
                    data: {
                        phone: cust.customer_phone_number || '',
                        email: cust.customer_Email_Address || ''
                    },
                    errors: {},
                    isEditingCustomer: false,
                    serviceAreaCheck: null,  // reset until geocoded
                });
                this.props.handleCustomer(cust.customer_id, cust.customer_name, "retail", cust);
                this.checkExistingCustomerServiceArea(cust);
            } else {
                this.setState( { found : "N"});
            }
        };

        // For an existing customer, the row is geocoded server-side at
        // insert/update. Prefer those stored coords (no API cost). Fall back
        // to forward-geocoding the address string only when the row lacks
        // them (geocoding can silently fail on the server side).
        checkExistingCustomerServiceArea = async (cust) => {
            const loc = this.props.currentLocation;
            if (!loc || !isMobileLocation(loc)) return;

            const stored = this.extractCustomerCoords(cust);
            if (stored) {
                this.setState({
                    customerLat: stored.lat,
                    customerLng: stored.lng,
                    serviceAreaCheck: this.checkServiceArea(stored.lat, stored.lng),
                });
                return;
            }

            // Fallback path — server didn't return geocoded coords.
            const address = cust?.customer_address;
            if (!address) return;
            try {
                const geo = await forwardGeocode(address);
                if (!geo || geo.lat == null || geo.lng == null) return;
                this.setState({
                    customerLat: geo.lat,
                    customerLng: geo.lng,
                    serviceAreaCheck: this.checkServiceArea(geo.lat, geo.lng),
                });
            } catch {
                // silent — warning just doesn't appear; not blocking the workflow
            }
        };

        extractCustomerCoords = (cust) => {
            if (!cust) return null;
            const lat = cust.customer_address_lat;
            const lng = cust.customer_address_long;
            if (lat == null || lng == null) return null;
            const numLat = Number(lat);
            const numLng = Number(lng);
            if (Number.isNaN(numLat) || Number.isNaN(numLng)) return null;
            return { lat: numLat, lng: numLng };
        };

        async getDealer(dealerId) {            
            const dealerRequest = "/dealers/" + dealerId;
            const { data : dealer } = await API.get(dealerRequest);
            let deal = dealer[0];            
            if (dealer.length > 0) {
                this.setState({ found: "Y" });
                this.setState({
                    name: deal.dealer_name, 
                    email: deal.dealer_email, 
                    customerId: deal.dealer_id, 
                    phone: deal.dealer_phone_number, 
                    address: deal.dealer_address_line1,
                    customer: deal
                });
                this.props.handleCustomer(deal.dealer_id, deal.dealer_name, "whole", deal);
            } else {
                this.setState({ found: "N" });
            }
        };

        async addCustomer(name, email, phone, address) {            
            const customer = {
                customerName : name,
                customerEmailAddress : email,
                customerPhoneNumber : phone,
                customerAddress : address,
                customerType : "Prospect",
                owningInstaller : this.props.installer.Installer_id
            };

            // hacky way to fix the state of the customer record in state
            const customer_internal = {
                customer_name : name,
                customer_Email_Address : email,
                customer_phone_number : phone,
                customer_address : address,
                customer_type : "Prospect",
                owning_installer : this.props.installer.Installer_id
            };

            const apiEndpoint =  "/customers";
            const response = await API.post(apiEndpoint, customer);
            const newCustomerId = (response.data && typeof response.data === 'object')
                ? (response.data.customer_id ?? response.data.insertId ?? response.data.id)
                : response.data;
            if (!newCustomerId) {
                console.error('[newCustomerForm] addCustomer: no id in response', response.data);
            }
            this.setState({ customerId: newCustomerId, found: "Y", customer: customer_internal });
            return { customerId: newCustomerId, customer: customer_internal };
        };

        /**
         * The installer this form is acting for.
         *
         * `typeId` is the canonical id from the parent; `installer.*` is a row
         * from installer_locations and uses snake_case (`installer_id`), with an
         * older capitalised spelling still in play. Resolved in ONE place because
         * two callers now need it and they must not drift: the list reads, and
         * the dealership create that stamps ownership.
         */
        resolveInstallerId() {
            return this.props.typeId
                || this.props.installer?.installer_id
                || this.props.installer?.Installer_id
                || null;
        }

        async addDealer(dealerData) {
            // The server seeds this dealership's vendor categories from what we
            // send here, and the category is part of the specialist-lookup URL —
            // a dealership with none can never fetch a specialist and cannot
            // raise any request. Sending nothing makes the server fall back to
            // 'Paint', which is a guess that silently decides what this
            // dealership is allowed to buy. Refuse instead.
            const installerCategories = String(this.props.installer?.installer_category || '').trim();
            if (!installerCategories) {
                console.error(
                    '[CustomerForm] Cannot create a dealership: the installer has no installer_category, so the dealership would have no vendor categories and could not request work.',
                    { installerKeys: this.props.installer ? Object.keys(this.props.installer) : null }
                );
                alert(
                    'Could not create the dealership: your shop has no service category set. ' +
                    'Set one in your profile first — without it the dealership would not be able to request any work.'
                );
                return;
            }

            const referringInstallerId = this.resolveInstallerId();
            if (!referringInstallerId) {
                // Loud rather than silent. A dealership created without an owner
                // looks successful and then cannot be found again, which is far
                // harder to diagnose than a refusal at the point of creation.
                console.error(
                    '[CustomerForm] Cannot create a dealership without an installer id — it would be orphaned and unfindable.',
                    { hasTypeId: !!this.props.typeId, installerKeys: this.props.installer ? Object.keys(this.props.installer) : null }
                );
                alert('Could not create the dealership: this session has no installer context. Reload and try again.');
                return;
            }

            this.setState({ creatingDealer: true });

            try {
                let groupId = this.state.selectedDealerGroupId;

                // If creating a new group, create it first
                if (this.state.isCreatingNewGroup && this.state.newDealerGroupName.trim()) {
                    try {
                        console.log("Creating new dealer group:", this.state.newDealerGroupName);
                        const { data: newGroup } = await API.post("/dealer-groups", {
                            name: this.state.newDealerGroupName.trim()
                        });
                        groupId = newGroup.group_id || newGroup.id;
                        console.log("New dealer group created with ID:", groupId);
                    } catch (groupError) {
                        console.error("Error creating dealer group:", groupError);
                        // Continue without group if creation fails
                        groupId = null;
                    }
                }

                // Create dealer directly - let backend handle Stripe customer creation
                const dealer = {
                    dealerName: dealerData.name,
                    dealerEmail: dealerData.email,
                    dealerPhoneNumber: dealerData.phone,
                    dealerAddressLine1: dealerData.address,
                    dealerAddressLine2: '',
                    dealerAddressCity: dealerData.city,
                    dealerAddressState: dealerData.state,
                    dealerAddressZip: dealerData.zip,
                    installerCategories,
                    assetType: this.state.newDealerAssetType || 'auto',
                    // Ownership. Without it the dealership is created with no
                    // installer attached, so `/dealerInstall/:installerId` has
                    // nothing to match it on and it is invisible everywhere
                    // afterwards — the exact bug that made a dealership created
                    // here unfindable on the Customers page. Same field name the
                    // public signup already sends.
                    referringInstallerId: referringInstallerId,
                    // Captured from the address picker. Null when the estimator typed
                    // an address instead of selecting a suggestion — the server still
                    // geocodes in that case, this just skips it when we already know.
                    placeId: dealerData.placeId || null,
                    latitude: dealerData.latitude ?? null,
                    longitude: dealerData.longitude ?? null,
                    dealerActive: 1,
                    customerContract: 'N'
                };

                console.log("Creating dealer (backend will handle Stripe):", dealer);

                const apiEndpoint = "/dealers";
                const { data: response } = await API.post(apiEndpoint, dealer);

                // Response should include dealerId from the enhanced backend
                const dealerId = response.dealerId || response;

                // If a group was selected or created, associate the dealer with it
                if (groupId) {
                    try {
                        console.log("Associating dealer", dealerId, "with group", groupId);
                        await API.post(`/dealer-groups/${groupId}/dealerships`, {
                            dealerId: dealerId
                        });
                        console.log("Dealer successfully associated with group");
                    } catch (assocError) {
                        console.error("Error associating dealer with group:", assocError);
                        // Don't fail the whole operation if association fails
                    }
                }

                // Create dealer internal object for state
                const dealer_internal = {
                    dealer_id: dealerId,
                    dealer_name: dealerData.name,
                    dealer_email: dealerData.email,
                    dealer_phone_number: dealerData.phone,
                    dealer_address_line1: dealerData.address,
                    dealer_address_city: dealerData.city,
                    dealer_address_state: dealerData.state,
                    dealer_address_zip: dealerData.zip,
                    stripe_customer_id: null, // Will be set by backend
                    // The wizard types itself off this row. Without it a
                    // just-created marine dealership would keep the Road/Water
                    // toggle until the estimator reselected it, because every
                    // other consumer reads asset_type from GET /dealers/:id.
                    asset_type: this.state.newDealerAssetType || 'auto'
                };

                this.setState({
                    customerId: dealerId,
                    found: "Y",
                    customer: dealer_internal,
                    creatingDealer: false,
                    // Reset dealer group state
                    selectedDealerGroupId: '',
                    newDealerGroupName: '',
                    isCreatingNewGroup: false,
                    newDealerAssetType: 'auto',
                    // Set display fields for the "Selected" view
                    name: dealerData.name,
                    email: dealerData.email,
                    phone: dealerData.phone,
                    address: `${dealerData.address}, ${dealerData.city}, ${dealerData.state} ${dealerData.zip}`
                });

                // Fire and forget distance calculation - backend already handles this
                console.log("Dealer creation complete");

                return dealerId;

            } catch (error) {
                console.error("Error creating dealer:", error);
                this.setState({ creatingDealer: false });

                // Show error to user
                const errorMessage = error.response?.data?.message || error.message || "Failed to create dealer";
                alert("Failed to create dealer: " + errorMessage);
                throw error;
            }
        };

        // Custom dropdown search handler
        handleSearchChange = (event) => {
            const value = event.target.value;
            this.setState({ 
                searchTerm: value,
                selectedIndex: -1 
            });

            if (!value.trim()) {
                this.setState({
                    filteredResults: [],
                    showDropdown: false
                });
                return;
            }

            // Filter based on current mode (dealer or customer)
            const sourceList = this.state.isDealer ? this.state.dealerList : this.state.customerList;
            const filtered = sourceList.filter(item =>
                item.listValue.toLowerCase().includes(value.toLowerCase())
            );

            // Always add "Add new..." option at the end
            const addNewOption = {
                id: 'add_new',
                listValue: this.state.isDealer ? 'Add new dealer...' : 'Add new customer...',
                isAddOption: true
            };

            const finalResults = [...filtered, addNewOption];

            this.setState({
                filteredResults: finalResults,
                showDropdown: finalResults.length > 0
            });
        };

        // Handle selection from dropdown (dealer, customer, or add new)
        handleSelection = (item) => {
            if (item.isAddOption) {
                // Handle "Add new..." selection
                if (this.state.isDealer) {
                    this.doAddDealerWindow();
                } else {
                    this.doAddWindow();
                }
            } else {
                // Handle regular selection
                this.setState({
                    searchTerm: item.listValue,
                    filteredResults: [],
                    showDropdown: false
                });
                
                if (this.state.isDealer) {
                    this.doSubmitDealer(item.dealer_id);
                } else {
                    this.doSubmit(item.customer_id);
                }
            }
        };

        handleKeyDown = (event) => {
            const { filteredResults, selectedIndex, showDropdown } = this.state;

            if (!showDropdown || filteredResults.length === 0) {
                return;
            }

            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    const nextIndex = selectedIndex < filteredResults.length - 1 ? selectedIndex + 1 : 0;
                    this.setState({ selectedIndex: nextIndex });
                    break;

                case 'ArrowUp':
                    event.preventDefault();
                    const prevIndex = selectedIndex > 0 ? selectedIndex - 1 : filteredResults.length - 1;
                    this.setState({ selectedIndex: prevIndex });
                    break;

                case 'Enter':
                    event.preventDefault();
                    if (selectedIndex >= 0 && filteredResults[selectedIndex]) {
                        this.handleSelection(filteredResults[selectedIndex]);
                    }
                    break;

                case 'Escape':
                    this.setState({
                        filteredResults: [],
                        showDropdown: false,
                        selectedIndex: -1
                    });
                    break;
                default:
                    break;
            }
        };

        // Handle input focus
        handleFocus = () => {
            if (this.state.searchTerm && this.state.filteredResults.length > 0) {
                this.setState({ showDropdown: true });
            }
        };

        // Handle input blur with delay to allow for clicks
        handleBlur = () => {
            setTimeout(() => {
                this.setState({ 
                    showDropdown: false,
                    selectedIndex: -1
                });
            }, 150);
        };

        clearSearch = () => {
            this.setState({ 
                searchTerm: "", 
                filteredResults: [],
                showDropdown: false,
                selectedIndex: -1,
                found: " "
            });
        };

        // go select the information for the selected customer      
        doSubmit = async (id) => {
            // Go and get the customer information from db 
            await this.getCustomer(id);
        };

        // go select the information for the selected dealer      
        doSubmitDealer = async (id) => {
            // Go and get the dealer information from db 
            await this.getDealer(id);
        };

        validate = () => {
            const options = { abortEarly: false };
            const { error } = JOI.validate(this.state.data, this.schema, options);
            if (!error) return null;
        
            const errors = {};
            for (let item of error.details) errors[item.path[0]] = item.message;
            return errors;
        };

        validateDealer = () => {
            const options = { abortEarly: false };
            const { error } = JOI.validate(this.state.dealerData, this.dealerSchema, options);
            if (!error) return null;
        
            const errors = {};
            for (let item of error.details) errors[item.path[0]] = item.message;
            return errors;
        };

        validateProperty = ({ name, value }) => {
            const obj = { [name]: value };
            const schema = { [name]: this.schema[name] };
            const { error } = JOI.validate(obj, schema);
            return error ? error.details[0].message : null;
        };

        validateDealerProperty = ({ name, value }) => {
            const obj = { [name]: value };
            const schema = { [name]: this.dealerSchema[name] };
            const { error } = JOI.validate(obj, schema);
            return error ? error.details[0].message : null;
        };
    
        handleDealerChange = (event) => {
            const { value } = event.target;
            this.setState( {selectedDealer : value });

            // selecting the dealer will do the same as selecting the customer
            this.setState( { found : "Y"});
            let dealerIndex = this.props.dealerships.findIndex(dealer => dealer.dealer_name === value);
            const dealer = this.props.dealerships[dealerIndex];

            this.setState( {name : dealer.dealer_name,
                email : dealer.dealer_email,
                phone : "",
                customerId : dealer.dealer_id});
            // Pass the full dealer row so downstream consumers (e.g.,
            // MobileAppointmentForm's coord lookup) get latitude/longitude.
            this.props.handleCustomer(dealer.dealer_id, dealer.dealer_name, "whole", dealer);
        }

        handleAddress = (place) => {
            const lat = place?.geometry?.location?.lat?.();
            const lng = place?.geometry?.location?.lng?.();
            this.setState({
                address: place.formatted_address,
                customerLat: typeof lat === 'number' ? lat : null,
                customerLng: typeof lng === 'number' ? lng : null,
                serviceAreaCheck: this.checkServiceArea(lat, lng),
            });
        }

        // Returns null when not applicable (fixed location, missing coords),
        // otherwise { inRange, distanceMiles, radiusMiles }. Caller renders
        // a warning when `!inRange`.
        checkServiceArea = (lat, lng) => {
            const loc = this.props.currentLocation;
            if (!loc || !isMobileLocation(loc)) return null;
            if (typeof lat !== 'number' || typeof lng !== 'number') return null;
            const base = getBaseCoords(loc);
            const radiusMiles = Number(loc.service_radius_miles);
            if (!base || !radiusMiles) return null;
            const meters = calculateDistance(lat, lng, base.lat, base.lng);
            const distanceMiles = meters / METERS_PER_MILE;
            return { inRange: distanceMiles <= radiusMiles, distanceMiles, radiusMiles };
        }

        renderServiceAreaWarning = () => {
            const check = this.state.serviceAreaCheck;
            if (!check || check.inRange) return null;
            return (
                <div className="alert alert-warning mt-2 mb-0" style={{ fontSize: 13 }} role="alert">
                    <i className="fa-sharp fa-regular fa-triangle-exclamation mr-2" aria-hidden="true" />
                    Outside this mobile crew's service area —{' '}
                    <strong>{check.distanceMiles.toFixed(1)} mi</strong> from base
                    (radius {check.radiusMiles} mi). Confirm with the customer before booking.
                </div>
            );
        }

        handleDealerAddress = (place) => {
            const dealerData = { ...this.state.dealerData };
            
            // Extract street address only (not the full formatted address)
            let streetAddress = '';
            let city = '';
            let state = '';
            let zip = '';
            
            // Extract components if available - build proper address fields
            if (place.address_components) {
                place.address_components.forEach(component => {
                    if (component.types.includes('street_number')) {
                        streetAddress = component.long_name + ' ';
                    }
                    if (component.types.includes('route')) {
                        streetAddress += component.long_name;
                    }
                    if (component.types.includes('locality')) {
                        city = component.long_name;
                    }
                    if (component.types.includes('administrative_area_level_1')) {
                        state = component.short_name;
                    }
                    if (component.types.includes('postal_code')) {
                        zip = component.long_name;
                    }
                });
            }
            
            // Set only the street address (street number + route)
            dealerData.address = streetAddress.trim() || place.name || 'Address not found';
            dealerData.city = city;
            dealerData.state = state;
            dealerData.zip = zip;

            // Identity and coordinates straight off the selected place, exactly as
            // the public dealer signup does. `/dealerInstall/:installerId` is
            // PROXIMITY-scoped, so a dealership the server could not place on a map
            // cannot fall inside any radius and never appears in the picker.
            // Sending these removes the server's geocode round trip and its
            // failure path rather than relying on it.
            dealerData.placeId = place.place_id || null;
            const loc = place.geometry && place.geometry.location;
            dealerData.latitude = loc ? (typeof loc.lat === 'function' ? loc.lat() : loc.lat) : null;
            dealerData.longitude = loc ? (typeof loc.lng === 'function' ? loc.lng() : loc.lng) : null;

            console.log('Parsed address components:', {
                street: dealerData.address,
                city: dealerData.city,
                state: dealerData.state,
                zip: dealerData.zip
            });
            
            this.setState({ dealerData });
        }

        handleChange = ({ currentTarget: input }) => {
            const errors = { ...this.state.errors };
            const errorMessage = this.validateProperty(input);
            if (errorMessage) errors[input.name] = errorMessage;
            else delete errors[input.name];
        
            const data = { ...this.state.data };
            data[input.name] = input.value;
        
            this.setState({ data, errors });
        };

        handleDealerDataChange = ({ currentTarget: input }) => {
            const dealerErrors = { ...this.state.dealerErrors };
            const errorMessage = this.validateDealerProperty(input);
            if (errorMessage) dealerErrors[input.name] = errorMessage;
            else delete dealerErrors[input.name];

            const dealerData = { ...this.state.dealerData };
            dealerData[input.name] = input.value;

            this.setState({ dealerData, dealerErrors });
        };

        // Dealer group handlers
        handleDealerGroupChange = (event) => {
            const value = event.target.value;
            if (value === 'new') {
                // Show the "Add new group" input field
                this.setState({
                    isCreatingNewGroup: true,
                    selectedDealerGroupId: ''
                });
            } else {
                this.setState({
                    selectedDealerGroupId: value,
                    isCreatingNewGroup: false,
                    newDealerGroupName: ''
                });
            }
        };

        handleNewGroupNameChange = (event) => {
            this.setState({ newDealerGroupName: event.target.value });
        };

        handleNameChange = (e) => {
            const name = e.currentTarget.value;
            this.setState({name});
        }
        
        handleEmailChange = (e) => {
            const email = e.currentTarget.value;
            
            // Update both state.email and state.data.email for validation
            const data = { ...this.state.data };
            data.email = email;
            
            // Validate the email field
            const errors = { ...this.state.errors };
            const errorMessage = this.validateProperty({ name: 'email', value: email });
            if (errorMessage) errors.email = errorMessage;
            else delete errors.email;
            
            this.setState({ email, data, errors });
        }
        
        handlePhoneChange = (e) => {
            const phone = e.currentTarget.value;
            
            // Update both state.phone and state.data.phone for validation
            const data = { ...this.state.data };
            data.phone = phone;
            
            // Validate the phone field
            const errors = { ...this.state.errors };
            const errorMessage = this.validateProperty({ name: 'phone', value: phone });
            if (errorMessage) errors.phone = errorMessage;
            else delete errors.phone;
            
            this.setState({ phone, data, errors });
        }

        // Check if form is valid for submission
        isFormValid = () => {
            return this.state.name && 
                   this.state.phone && 
                   this.state.email && 
                   !this.state.errors.phone && 
                   !this.state.errors.email;
        }

        // Check if dealer form is valid for submission - simplified since Google Maps auto-populates
        isDealerFormValid = () => {
            const { dealerData, dealerErrors, isCreatingNewGroup, newDealerGroupName } = this.state;

            // If creating a new group, the group name must be provided
            if (isCreatingNewGroup && !newDealerGroupName.trim()) {
                return false;
            }

            return dealerData.name &&
                   dealerData.email &&
                   dealerData.phone &&
                   dealerData.address &&
                   dealerData.city &&    // Auto-populated by Google Maps
                   dealerData.state &&   // Auto-populated by Google Maps
                   dealerData.zip &&     // Auto-populated by Google Maps
                   Object.keys(dealerErrors).length === 0;
        }
                
        doAdd = async () => {
            // Validate the form before submission
            const errors = this.validate();
            if (errors) {
                this.setState({ errors });
                return;
            }

            const { customerId, customer } = await this.addCustomer(
                this.state.name, this.state.email, this.state.phone, this.state.address
            );
            if (!customerId) return;
            this.props.handleCustomer(customerId, this.state.name, "retail", customer);
        };

        async updateCustomer(name, email, phone, address) {
            const customer = {
                customerName: name,
                customerEmailAddress: email,
                customerPhoneNumber: phone,
                customerAddress: address,
                customerId: this.state.customerId
            };

            const apiEndpoint = "/customer/" + this.state.customerId;
            await API.put(apiEndpoint, customer);

            const customer_internal = {
                customer_name: name,
                customer_Email_Address: email,
                customer_phone_number: phone,
                customer_address: address,
                customer_id: this.state.customerId
            };

            this.setState({ customer: customer_internal });
            this.props.handleCustomer(this.state.customerId, name, "retail", customer_internal);
        };

        doUpdate = async () => {
            const errors = this.validate();
            if (errors) {
                this.setState({ errors });
                return;
            }

            await this.updateCustomer(this.state.name, this.state.email, this.state.phone, this.state.address);
            this.setState({ isEditingCustomer: false });
        };

        doAddDealer = async () => {
            // Validate the dealer form before submission
            const dealerErrors = this.validateDealer();
            if (dealerErrors) {
                this.setState({ dealerErrors });
                return;
            }

            try {
                // Create dealer with Stripe integration
                const dealerId = await this.addDealer(this.state.dealerData);
                
                // Update state and notify parent
                this.setState({ found: "Y" });
                this.props.handleCustomer(dealerId, this.state.dealerData.name, "whole", this.state.customer);
            } catch (error) {
                console.error("Failed to create dealer:", error);
            }
        };

        doAddWindow = () => {
            this.setState({
                found : "N", 
                name : this.state.searchTerm,
                email: "",
                phone: "",
                address: "",
                showDropdown: false,
                errors: {} // Clear any previous errors
            });
        }

        doAddDealerWindow = () => {
            const dealerData = { ...this.state.dealerData };
            dealerData.name = this.state.searchTerm;

            this.setState({
                found: "N",
                dealerData,
                showDropdown: false,
                dealerErrors: {}, // Clear any previous errors
                // Reset dealer group state for new form
                selectedDealerGroupId: '',
                newDealerGroupName: '',
                isCreatingNewGroup: false
            });
        }

        render() {
            if (this.props.currentStep !== 1) {
                return null
            };

            if (this.props.installer > ""){
                if (this.props.installer.services && this.props.installer.services.includes("whole") ) {
                    var dealerList = this.props.dealerships.map(a=>a.dealer_name);
                    dealerList.unshift("Dealerships");
                }
            }

            return (
                <React.Fragment>
                    {this.props.mode === "search" && <form className="form-container p-5">
                        
                        {/* Customer/Dealer Toggle */}
                        <div className="form-row justify-content-md-center mb-4">
                            <div className="btn-group btn-group-toggle" data-toggle="buttons">
                                <label className={`btn btn-outline-primary ${!this.state.isDealer ? 'active' : ''}`}>
                                    <input 
                                        type="radio" 
                                        name="customerType" 
                                        value="customer" 
                                        checked={!this.state.isDealer} 
                                        onChange={() => !this.state.isDealer || this.handleToggleChange()}
                                    /> Customer
                                </label>
                                <label className={`btn btn-outline-primary ${this.state.isDealer ? 'active' : ''}`}>
                                    <input 
                                        type="radio" 
                                        name="customerType" 
                                        value="dealer" 
                                        checked={this.state.isDealer} 
                                        onChange={() => this.state.isDealer || this.handleToggleChange()}
                                    /> Dealer
                                </label>
                            </div>
                        </div>

                        {/* Universal Search Bar - No separate Add button needed */}
                        <div className="form-row justify-content-md-center search-bar-container">
                            <div className='form-group col-md-5' style={{ position: 'relative' }}>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={this.state.isDealer ? "Type to search dealer name/phone..." : "Type to search customer name/phone..."}
                                        autoFocus
                                        value={this.state.searchTerm}
                                        onChange={this.handleSearchChange}
                                        onKeyDown={this.handleKeyDown}
                                        onFocus={this.handleFocus}
                                        onBlur={this.handleBlur}
                                        autoComplete="off"
                                    />
                                    {this.state.searchTerm && (
                                        <div className="input-group-append">
                                            <button 
                                                className="btn btn-outline-secondary"
                                                onClick={this.clearSearch}
                                                type="button"
                                                title="Clear search"
                                            >
                                                <i className="fa-sharp fa-regular fa-times"></i>
                                            </button>
                                        </div>
                                    )}
                                </div>
                                
                                {/* Custom dropdown */}
                                {this.state.showDropdown && (
                                    <div 
                                        style={{
                                            position: 'absolute',
                                            top: '100%',
                                            left: 0,
                                            right: 0,
                                            backgroundColor: 'var(--color-bg-card)',
                                            border: '1px solid var(--color-border)',
                                            borderTop: 'none',
                                            maxHeight: '200px',
                                            overflowY: 'auto',
                                            zIndex: 1000,
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                        }}
                                    >
                                        {this.state.filteredResults.map((item, index) => (
                                            <div
                                                key={item.isAddOption ? item.id : (this.state.isDealer ? item.dealer_id : item.customer_id)}
                                                style={{
                                                    padding: '8px 12px',
                                                    cursor: 'pointer',
                                                    backgroundColor: index === this.state.selectedIndex ? 'var(--color-bg-panel)' : 'var(--color-bg-card)',
                                                    borderBottom: index < this.state.filteredResults.length - 1 ? '1px solid var(--color-border-light)' : 'none',
                                                    fontStyle: item.isAddOption ? 'italic' : 'normal',
                                                    color: item.isAddOption ? 'var(--color-info)' : 'var(--color-text-primary)'
                                                }}
                                                onMouseDown={(e) => {
                                                    e.preventDefault(); // Prevent blur from firing
                                                    this.handleSelection(item);
                                                }}
                                                onMouseEnter={() => this.setState({ selectedIndex: index })}
                                            >
                                                {item.isAddOption && <i className="fa-sharp fa-regular fa-plus" style={{marginRight: '8px'}}></i>}
                                                {item.listValue}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </form>}

                    {this.state.found === "Y" && this.state.isDealer && <div>
                    <h5 className="text-center bold p-5">Dealer Selected</h5>
                    <div className="col-lg-12 bold text-center">
                    <p>{this.state.phone}</p>
                    <p>{this.state.name}</p>
                    <p>{this.state.email}</p>
                    <p>{this.state.address}</p>
                    </div></div>}

                    {this.state.found === "Y" && !this.state.isDealer && <div className="m-2 shadow bg-white">
                    <h5 className="text-center bold pt-4 pb-2">Customer Selected</h5>

                    {!this.state.isEditingCustomer ? (
                        <div className="pb-4 bg-white">
                            <div className="form-row justify-content-md-center">
                                <div className="col-md-5 text-center">
                                    <p className="mb-1"><strong>{this.state.name}</strong></p>
                                    <p className="mb-1 text-muted">{this.state.email}</p>
                                    <p className="mb-1 text-muted">{this.state.phone}</p>
                                    {this.state.address && <p className="mb-1 text-muted">{this.state.address}</p>}
                                    {this.renderServiceAreaWarning()}
                                </div>
                            </div>
                            <div className="form-row justify-content-md-center mt-3">
                                <button type="button"
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => this.setState({ isEditingCustomer: true })}>
                                    <i className="fa-sharp fa-regular fa-pen-to-square mr-1"></i>
                                    Edit Details
                                </button>
                            </div>
                        </div>
                    ) : (
                        <form className="p-5 bg-white">
                            <div className="form-row justify-content-md-center">
                                <div className="form-group col-md-2 text-center">
                                    <label htmlFor="name"
                                    className="bold mt-1">Full Name *</label>
                                </div>
                                <div className="form-group col-md-3">
                                    <input type='text'
                                    className="form-control"
                                    name='name'
                                    value={this.state.name}
                                    onChange={this.handleNameChange}/>
                                </div>
                            </div>
                            <div className="form-row justify-content-md-center">
                                <div className="form-group col-md-2 text-center">
                                    <label htmlFor="email"
                                    className="bold mt-1">Email *</label>
                                </div>
                                <div className="form-group col-md-3">
                                    <input type='email'
                                    className={`form-control ${this.state.errors.email ? 'is-invalid' : ''}`}
                                    name='email'
                                    value={this.state.email}
                                    onChange={this.handleEmailChange}
                                    required/>
                                    {this.state.errors.email && (
                                        <div className="invalid-feedback">
                                            {this.state.errors.email}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="form-row justify-content-md-center">
                                <div className="form-group col-md-2 text-center">
                                    <label htmlFor="phone"
                                    className="bold mt-1">Phone *</label>
                                </div>
                                <div className="form-group col-md-3">
                                    <input type='text'
                                    className={`form-control ${this.state.errors.phone ? 'is-invalid' : ''}`}
                                    name='phone'
                                    value={this.state.phone}
                                    onChange={this.handlePhoneChange}
                                    required/>
                                    {this.state.errors.phone && (
                                        <div className="invalid-feedback">
                                            {this.state.errors.phone}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="form-row justify-content-md-center">
                                <div className="form-group col-md-2 text-center">
                                    <label className="bold mt-1" htmlFor="address">Address </label>
                                </div>
                                <div className="form-group col-md-3">
                                    <Autocomplete
                                        apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                                        style={{ width: "100%" }}
                                        onPlaceSelected={(place) => this.handleAddress(place)}
                                        options={{
                                            types: [],
                                            componentRestrictions: { country: "us" },
                                        }}
                                        defaultValue={this.state.address}/>
                                    {this.renderServiceAreaWarning()}
                                </div>
                            </div>
                            <div className="form-row justify-content-md-center">
                                <div className="form-group col-md-2 d-flex justify-content-between">
                                    <button type="button"
                                        className="jv-btn jv-btn-tertiary"
                                        onClick={() => this.setState({ isEditingCustomer: false, errors: {} })}>
                                        Cancel
                                    </button>
                                    <button type="button"
                                        className="jv-btn jv-btn-primary"
                                        onClick={this.doUpdate}
                                        disabled={!this.isFormValid()}>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    )}
                </div>}
                    
                    {this.state.found === "N" && !this.state.isDealer && <div className="m-2 shadow bg-white">
                    <h5 className="text-center bold pt-3 pb-2 px-3">Add New Customer Details</h5>
                    <form className="px-5 pb-4 bg-white">
                        <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2 text-center">
                                <label htmlFor="name" 
                                className="bold mt-1">Full Name *</label>
                            </div>
                            <div className="form-group col-md-3">
                                <input type='text' 
                                className="form-control" 
                                name='name' 
                                autoFocus
                                value={this.state.name} 
                                onChange={this.handleNameChange}/> 
                            </div>
                            </div>
                            <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2 text-center">
                                <label htmlFor="email" 
                                className="bold mt-1">Email *</label>
                            </div>
                            <div className="form-group col-md-3">
                                <input type='email' 
                                className={`form-control ${this.state.errors.email ? 'is-invalid' : ''}`}
                                name='email' 
                                value={this.state.email} 
                                onChange={this.handleEmailChange}
                                required/> 
                                {this.state.errors.email && (
                                    <div className="invalid-feedback">
                                        {this.state.errors.email}
                                    </div>
                                )}
                            </div>
                            </div>
                            <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2 text-center">
                                <label htmlFor="phone" 
                                className="bold mt-1">Phone *</label>
                            </div>
                            <div className="form-group col-md-3">
                                <input type='text' 
                                className={`form-control ${this.state.errors.phone ? 'is-invalid' : ''}`}
                                name='phone' 
                                value={this.state.phone} 
                                onChange={this.handlePhoneChange}
                                required/> 
                                {this.state.errors.phone && (
                                    <div className="invalid-feedback">
                                        {this.state.errors.phone}
                                    </div>
                                )}
                            </div>

                            </div>
                            <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2 text-center">
                                <label className="bold mt-1" htmlFor="address">Address </label>
                            </div>
                            <div className="form-group col-md-3">
                                <Autocomplete
                                    apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                                    style={{ width: "100%" }}
                                    onPlaceSelected={(place) => this.handleAddress(place)}
                                    options={{
                                        types: [],
                                        componentRestrictions: { country: "us" },
                                    }}
                                    defaultValue={this.state.address}/>
                                {this.renderServiceAreaWarning()}
                            </div>
                        </div>

                            <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2">
                                <button type="button"
                                className="jv-btn jv-btn-primary btn-block"
                                onClick={this.doAdd}
                                disabled={!this.isFormValid()}>
                                Add Customer
                                </button>
                            </div>
                        </div>
                    </form>
                </div>}

                {/* NEW: Add Dealer Form - White background */}
                {this.state.found === "N" && this.state.isDealer && <div className="m-2 shadow bg-white">
                    <h5 className="text-center bold pt-3 pb-2 px-3">Add New Dealer Details</h5>
                    <form className="px-5 pb-4 bg-white">
                        {/* Dealer Group Selection */}
                        <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2 text-center">
                                <label htmlFor="dealerGroup" className="bold mt-1">Dealer Group</label>
                            </div>
                            <div className="form-group col-md-3">
                                <select
                                    className="form-control"
                                    name="dealerGroup"
                                    value={this.state.isCreatingNewGroup ? 'new' : this.state.selectedDealerGroupId}
                                    onChange={this.handleDealerGroupChange}
                                >
                                    <option value="">-- No Group (Optional) --</option>
                                    {this.state.dealerGroups.map(group => (
                                        <option key={group.group_id || group.id} value={group.group_id || group.id}>
                                            {group.group_name || group.name}
                                        </option>
                                    ))}
                                    <option value="new">Add New Dealer Group</option>
                                </select>
                            </div>
                        </div>

                        {/* New Dealer Group Name Input - shown when "Add New" is selected */}
                        {this.state.isCreatingNewGroup && (
                            <div className="form-row justify-content-md-center">
                                <div className="form-group col-md-2 text-center">
                                    <label htmlFor="newGroupName" className="bold mt-1">New Group Name *</label>
                                </div>
                                <div className="form-group col-md-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="newGroupName"
                                        placeholder="Enter new dealer group name"
                                        value={this.state.newDealerGroupName}
                                        onChange={this.handleNewGroupNameChange}
                                    />
                                </div>
                            </div>
                        )}

                        <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2 text-center">
                                <label htmlFor="dealerName" className="bold mt-1">Dealer Name *</label>
                            </div>
                            <div className="form-group col-md-3">
                                <input
                                    type='text'
                                    className={`form-control ${this.state.dealerErrors.name ? 'is-invalid' : ''}`}
                                    name='name'
                                    autoFocus
                                    value={this.state.dealerData.name}
                                    onChange={this.handleDealerDataChange}
                                />
                                {this.state.dealerErrors.name && (
                                    <div className="invalid-feedback">{this.state.dealerErrors.name}</div>
                                )}
                            </div>
                        </div>
                        
                        <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2 text-center">
                                <label htmlFor="dealerEmail" className="bold mt-1">Billing Email *</label>
                            </div>
                            <div className="form-group col-md-3">
                                <input 
                                    type='email' 
                                    className={`form-control ${this.state.dealerErrors.email ? 'is-invalid' : ''}`}
                                    name='email' 
                                    value={this.state.dealerData.email} 
                                    onChange={this.handleDealerDataChange}
                                /> 
                                {this.state.dealerErrors.email && (
                                    <div className="invalid-feedback">{this.state.dealerErrors.email}</div>
                                )}
                            </div>
                        </div>

                        <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2 text-center">
                                <label htmlFor="dealerPhone" className="bold mt-1">Phone *</label>
                            </div>
                            <div className="form-group col-md-3">
                                <input 
                                    type='text' 
                                    className={`form-control ${this.state.dealerErrors.phone ? 'is-invalid' : ''}`}
                                    name='phone' 
                                    value={this.state.dealerData.phone} 
                                    onChange={this.handleDealerDataChange}
                                /> 
                                {this.state.dealerErrors.phone && (
                                    <div className="invalid-feedback">{this.state.dealerErrors.phone}</div>
                                )}
                            </div>
                        </div>

                        <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2 text-center">
                                <label className="bold mt-1" htmlFor="dealerAddress">Address *</label> 
                            </div>
                            <div className="form-group col-md-3">
                                <Autocomplete
                                    apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                                    style={{ width: "100%" }}
                                    className={`form-control ${this.state.dealerErrors.address ? 'is-invalid' : ''}`}
                                    onPlaceSelected={(place) => this.handleDealerAddress(place)}
                                    options={{
                                        types: [],
                                        componentRestrictions: { country: "us" },
                                    }}
                                    defaultValue={this.state.dealerData.address}
                                />
                                {this.state.dealerErrors.address && (
                                    <div className="invalid-feedback">{this.state.dealerErrors.address}</div>
                                )}
                                
                            </div>
                        </div>

                        <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2 text-center">
                                <label htmlFor="dealershipType" className="bold mt-1">Dealership Type *</label>
                            </div>
                            <div className="form-group col-md-3">
                                <select
                                    className="form-control"
                                    name="dealershipType"
                                    value={this.state.newDealerAssetType}
                                    onChange={(e) => this.setState({ newDealerAssetType: e.target.value })}
                                >
                                    <option value="auto">Automotive</option>
                                    <option value="marine">Marine</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-row justify-content-md-center">
                            <div className="form-group col-md-2">
                                <button
                                    type="button"
                                    className="jv-btn jv-btn-primary btn-block"
                                    onClick={this.doAddDealer}
                                    disabled={!this.isDealerFormValid() || this.state.creatingDealer}
                                >
                                    {this.state.creatingDealer ? 'Adding Dealer...' : 'Add Dealer'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>}

                </React.Fragment>
            )
        }
}